import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { PublicProgramService } from '../../../api/external-web/public-program.service';
import {
  LocationOverlayComponent,
  RateProvisionsOverlayComponent,
  StaticDynamicTableOqmsComponent,
} from '@loup-transload-ui-app/common-components';
import { CommonHelperService } from '@loup-transload-ui-app/common-services';
import { TitleCasePipe } from '@loup-transload-ui-app/common-pipes';

@Component({
  selector: 'app-public-review',
  standalone: true,
  imports: [
    CommonModule,
    StaticDynamicTableOqmsComponent,
    RateProvisionsOverlayComponent,
    LocationOverlayComponent,
    TitleCasePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [DatePipe],
  templateUrl: './public-review.component.html',
  styleUrls: ['./public-review.component.scss'],
})
export class PublicReviewComponent implements OnInit {
  private readonly publicProgramService = inject(PublicProgramService);
  private readonly commonService = inject(CommonHelperService);
  public datePipe = inject(DatePipe);
  @Input() publicProgramData: any = {};
  @Input() currentId = null;
  @Output() updateStatus = new EventEmitter<any>();
  public tableHeight: any = '35em';
  public responseData: any = {};
  public showReviewDetails = false;
  public loupLogImagePath = 'assets/images/LOUP-icon.jpg';
  public uprrImagePath = 'assets/images/uprr-straight-icon.jpg';
  public readonly = true;
  public selectedRailServices = '';
  public selectedTransloadTruckServices = '';
  public selectedRailTruckServices = '';
  public selectedTransloadServices = '';
  public selectedTruckServices = '';
  public showNoDataAvailable = false;
  public columns: any[] = [
    { value: 'railOriginGroup', key: 'Origin' },
    { value: 'railDestinationGroup', key: 'Destination' },
    { value: 'railRoute', key: 'Rail Route' },
    { value: 'stcc', key: 'STCC' },
    { value: 'equipmentGroup', key: 'Equipment Type' },
    { value: 'railCarType', key: 'Equipment Sub Type' },
    { value: 'railcarOwnership', key: 'Equipment Ownership' },
    { value: 'transloadType', key: 'Transload Type' },
    { value: 'truckType', key: 'Truck Type' },
    { value: 'product', key: 'Onion/Potato' },
    { value: 'trucksPerCar', key: 'Trucks per Railcar' },
    { value: 'customerRate', key: 'Customer Rate' },
  ];
  public rows: any = [];
  railTruckColumns: any[] = [
    { value: 'railOriginGroup', key: 'Origin' },
    { value: 'railDestinationGroup', key: 'Destination' },
    { value: 'railRoute', key: 'Rail Route' },
    { value: 'stcc', key: 'STCC' },
    { value: 'equipmentGroup', key: 'Equipment Type' },
    { value: 'railCarType', key: 'Equipment Sub Type' },
    { value: 'railcarOwnership', key: 'Equipment Ownership' },
    { value: 'transloadType', key: 'Transload Type' },
    { value: 'truckType', key: 'Truck Type' },
    { value: 'product', key: 'Onion/Potato' },
    { value: 'trucksPerCar', key: 'Trucks per Railcar' },
    { value: 'customerRate', key: 'Customer Rate' },
  ];
  public railTruckRows: any = [];
  public transloadTruckColumns: any[] = [
    { value: 'railOriginGroup', key: 'Origin' },
    { value: 'railDestinationGroup', key: 'Destination' },
    { value: 'stcc', key: 'STCC' },
    { value: 'equipmentType', key: 'Equipment Type' },
    { value: 'equipmentSubType', key: 'Equipment Sub Type' },
    { value: 'transloadType', key: 'Transload Type' },
    { value: 'truckType', key: 'Truck Type' },
    { value: 'product', key: 'Onion/Potato' },
    { value: 'trucksPerCar', key: 'Trucks per Railcar' },
    { value: 'customerRate', key: 'Customer Rate' },
  ];
  public transloadTruckRows: any = [];
  transloadColumns: any[] = [
    { value: 'service', key: 'Service' },
    { value: 'stcc', key: 'STCC' },
    { value: 'equipmentType', key: 'Equipment Type' },
    { value: 'equipmentSubType', key: 'Equipment Sub Type' },
    { value: 'transloadType', key: 'Transload Type' },
    { value: 'truckType', key: 'Truck Type' },
    { value: 'trucks', key: 'Trucks Per Railcar' },
    { value: 'rates', key: 'Customer Rate' },
  ];
  transloadRows: any = [];
  truckColumns: any[] = [
    { value: 'railOriginGroup', key: 'Origin' },
    { value: 'railDestinationGroup', key: 'Destination' },
    { value: 'stcc', key: 'STCC' },
    { value: 'truckType', key: 'Truck Type' },
    { value: 'baseRate', key: 'Customer Rate' },
  ];
  truckRows: any = [];
  storageColumns: any[] = [
    { value: 'service', key: 'Service' },
    { value: 'serviceLocation', key: 'Service Location' },
    { value: 'stcc', key: 'STCC' },
    { value: 'storageTier', key: 'Storage Tier (in Days)' },
    { value: 'rateComment', key: 'Rate Comment' },
    { value: 'rate', key: 'Customer Rate' },
  ];
  storageRows: any = [];
  addidationalChargesColumns: any[] = [
    { value: 'service', key: 'Service' },
    { value: 'serviceLocation', key: 'Service Location' },
    { value: 'stcc', key: 'STCC' },
    { value: 'rateComment', key: 'Rate Comment' },
    { value: 'rate', key: 'Customer Rate' },
  ];
  addidationalChargesRows: any = [];
  locationColumns: any[] = [
    { value: 'city', key: 'City' },
    { value: 'state', key: 'State' },
    { value: 'country', key: 'Country' },
  ];
  locationRows: any = [];
  public isServiceCallOn: any = false;
  public rateProvisionData: any = [];
  public commentData = '';
  provisionsList: any = [];
  public isOverlayOpen = false;
  public isTableOverlayOpen = false;
  public locationType = '';

  ngOnInit(): void {
    this.showNoDataAvailable = false;
    this.getRailServices();
    this.getTransloadServices();
    this.getTruckServices();
  }

  isLumber(): boolean {
    const text = this.publicProgramData?.commodityCategory.code.toLowerCase();
    const isLumber = text === 'lumber' || text === 'lumber - panel products';
    return isLumber;
  }

  refresh(data) {
    this.publicProgramData = data;
    this.getReviewScreenData();
    this.showNoDataAvailable = false;
    this.getRailServices();
    this.getTransloadServices();
    this.getTruckServices();
  }

  sortProvisions() {
    this.sortedItems.forEach((listItem) => {
      const obj = {
        name: '',
        list: [],
      };
      if (
        this.provisionsList.length > 0 &&
        this.provisionsList.filter(
          (item) => item.name === listItem.provisionType
        ).length > 0
      ) {
        this.provisionsList
          .find((item) => item.name === listItem.provisionType)
          .list.push(listItem);
      } else {
        obj.name = listItem.provisionType;
        obj.list.push(listItem);
        this.provisionsList.push(obj);
      }
    });
  }

  getTruckServices() {
    const truckName = this.publicProgramData?.includedServices.find((item) =>
      item.code.toLowerCase().includes('trucking only')
    )?.description;
    if (truckName) {
      this.selectedTruckServices = truckName;
    }
  }

  getTransloadServices() {
    const transloadName = this.publicProgramData?.includedServices.find(
      (item) => item.code.toLowerCase().includes('transload only')
    )?.description;
    if (transloadName) {
      this.selectedTransloadServices = transloadName;
    }
  }

  getRailServices(): void {
    const hasRail = this.publicProgramData?.includedServices.some((item) =>
      item.code.toLowerCase().includes('rail')
    );
    const moveType = this.publicProgramData?.moveType?.toLowerCase();
    const services = this.publicProgramData?.includedServices || [];
    let matchCode = '';
    let selectedRailService = '';
    let selectedTruckService = '';
    if (hasRail) {
      if (moveType === 'origin') {
        matchCode = 'Origin transload, Rail';
        if (
          services.some(
            (item) => item.code?.toLowerCase() === matchCode.toLowerCase()
          )
        ) {
          selectedRailService = services.find(
            (item) => item.code === 'Origin transload, Rail'
          )?.description;
        }
        if (
          services.some(
            (item) => item.code?.toLowerCase() !== matchCode.toLowerCase()
          )
        ) {
          selectedTruckService = services.find(
            (item) => item.code === 'Origin truck, transload, Rail'
          )?.description;
        }
      } else {
        matchCode = 'rail, destination transload and trucking';
        if (
          services.some(
            (item) => item.code?.toLowerCase() === matchCode.toLowerCase()
          )
        ) {
          selectedTruckService = services.find(
            (item) => item.code === 'Rail, Destination transload and trucking'
          )?.description;
        }
        if (
          services.some(
            (item) => item.code?.toLowerCase() !== matchCode.toLowerCase()
          )
        ) {
          selectedRailService = services.find(
            (item) => item.code === 'Rail, Destination transload'
          )?.description;
        }
      }
      this.selectedRailServices = selectedRailService;
      this.selectedRailTruckServices = selectedTruckService;
    }
    if (
      services.some(
        (item) =>
          item.code?.toLowerCase() === 'destination transload and trucking' ||
          item.code?.toLowerCase() === 'origin trucking and transload'
      )
    ) {
      this.selectedTransloadTruckServices =
        moveType === 'origin'
          ? 'Origin Trucking, Transload'
          : 'Destination Transload, Trucking';
    }
  }

  get getStccList() {
    return (
      this.publicProgramData?.stcc
        ?.map((service) => service.productCode)
        .join(', ') || ''
    );
  }

  get includedServicesList() {
    return (
      this.publicProgramData?.includedServices
        ?.map((service) => service.description)
        .join(', ') || ''
    );
  }

  /** rows for rail */
  createTableRows() {
    this.rows = this.responseData.railRates.map((columnObject: any) => {
      let groupIdOrigin = '';
      let groupIdDestination = '';
      let railOriginGroup = '';
      let railDestinationGroup = '';
      let originDetails = '';
      let destinationDetails = '';
      if (this.publicProgramData?.moveType.toLowerCase() === 'origin') {
        groupIdDestination = columnObject.destnationRailGroup;
        railOriginGroup =
          this.publicProgramData?.transloadVendor.city +
          ', ' +
          this.publicProgramData?.transloadVendor.state +
          ', ' +
          this.publicProgramData?.transloadVendor.country;
        originDetails =
          this.publicProgramData?.transloadVendor.name +
          ', ' +
          this.publicProgramData?.transloadVendor.city +
          ', ' +
          this.publicProgramData?.transloadVendor.state +
          ', ' +
          this.publicProgramData?.transloadVendor.country;
        railDestinationGroup = columnObject.destnationRailGroup;
      }
      if (this.publicProgramData?.moveType.toLowerCase() === 'destination') {
        groupIdOrigin = columnObject.originRailGroup;
        railOriginGroup = columnObject.originRailGroup;
        railDestinationGroup =
          this.publicProgramData?.transloadVendor.city +
          ', ' +
          this.publicProgramData?.transloadVendor.state +
          ', ' +
          this.publicProgramData?.transloadVendor.country;
        destinationDetails =
          this.publicProgramData?.transloadVendor.name +
          ', ' +
          this.publicProgramData?.transloadVendor.city +
          ', ' +
          this.publicProgramData?.transloadVendor.state +
          ', ' +
          this.publicProgramData?.transloadVendor.country;
      }
      return {
        ...columnObject,
        groupIdOrigin: groupIdOrigin,
        groupIdDestination: groupIdDestination,
        railOriginGroup: railOriginGroup,
        destinationDetails: destinationDetails,
        originDetails: originDetails,
        trucksPerCar: columnObject.trucksPerCar
          ? columnObject.trucksPerCar
          : '0',
        transloadType: columnObject.transloadType
          ? columnObject.transloadType.displayText
          : '',
        truckType: columnObject.truckType
          ? columnObject.truckType.displayText
          : '',
        stcc: columnObject.stcc ? columnObject.stcc.productCode : '',
        railDestinationGroup: railDestinationGroup,
        customerRate: this.formatToFixed(columnObject.customerRate, '$0.00'),
      };
    });
  }

  createProduceTableRows() {
    this.rows = this.responseData.railRates.map((columnObject: any) => {
      let groupIdOrigin = '';
      let groupIdDestination = '';
      let railOriginGroup = '';
      let railDestinationGroup = '';
      let originDetails = '';
      let destinationDetails = '';
      if (this.publicProgramData?.moveType.toLowerCase() === 'origin') {
        groupIdDestination = columnObject.destnationRailGroup;
        railOriginGroup =
          this.publicProgramData?.transloadVendor.name +
          ', ' +
          this.publicProgramData?.transloadVendor.city +
          ', ' +
          this.publicProgramData?.transloadVendor.state +
          ', ' +
          this.publicProgramData?.transloadVendor.country;
        originDetails =
          this.publicProgramData?.transloadVendor.city +
          ', ' +
          this.publicProgramData?.transloadVendor.state +
          ', ' +
          this.publicProgramData?.transloadVendor.country;
        railDestinationGroup = columnObject.destnationRailGroup;
      }
      if (this.publicProgramData?.moveType.toLowerCase() === 'destination') {
        groupIdOrigin = columnObject.originRailGroup;
        railOriginGroup = columnObject.originRailGroup;
        railDestinationGroup =
          this.publicProgramData?.transloadVendor.city +
          ', ' +
          this.publicProgramData?.transloadVendor.state +
          ', ' +
          this.publicProgramData?.transloadVendor.country;
        destinationDetails =
          this.publicProgramData?.transloadVendor.name +
          ', ' +
          this.publicProgramData?.transloadVendor.city +
          ', ' +
          this.publicProgramData?.transloadVendor.state +
          ', ' +
          this.publicProgramData?.transloadVendor.country;
      }
      return {
        ...columnObject,
        groupIdOrigin: groupIdOrigin,
        groupIdDestination: groupIdDestination,
        railOriginGroup: railOriginGroup,
        trucksPerCar: columnObject.trucksPerCar
          ? columnObject.trucksPerCar
          : '0',
        destinationDetails: destinationDetails,
        transloadType: columnObject.transloadType
          ? columnObject.transloadType.displayText
          : '',
        truckType: columnObject.truckType
          ? columnObject.truckType.displayText
          : '',
        stcc: columnObject.stcc ? columnObject.stcc.productCode : '',
        originDetails: originDetails,
        railDestinationGroup: railDestinationGroup,
        customerRate: this.formatToFixed(columnObject.customerRate, '$0.00'),
      };
    });
  }

  private formatToFixed(value: any, defaultValue = '') {
    return value
      ? `$${value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : defaultValue;
  }

  /** rows for rail transload truck */
  createRailTruckTableRows() {
    this.railTruckRows = this.responseData.truckTransloadRailRates.map(
      (columnObject: any) => {
        let originName = '';
        let destinationName = '';
        let groupIdOrigin = '';
        let groupIdDestination = '';
        let originDetails = '';
        let destinationDetails = '';
        if (this.publicProgramData?.moveType.toLowerCase() === 'origin') {
          originName =
            columnObject.truckLocation.city +
            ', ' +
            columnObject.truckLocation.state +
            ', ' +
            columnObject.truckLocation.country;
          originDetails =
            columnObject.truckLocation.name +
            ', ' +
            columnObject.truckLocation.city +
            ', ' +
            columnObject.truckLocation.state +
            ', ' +
            columnObject.truckLocation.country;
          destinationName = columnObject.destnationRailGroup;
          groupIdDestination = columnObject.destnationRailGroup;
        }
        if (this.publicProgramData?.moveType.toLowerCase() === 'destination') {
          originName = columnObject.originRailGroup;
          groupIdOrigin = columnObject.originRailGroup;
          destinationName =
            columnObject.truckLocation.city +
            ', ' +
            columnObject.truckLocation.state +
            ', ' +
            columnObject.truckLocation.country;
          destinationDetails =
            columnObject.truckLocation.name +
            ', ' +
            columnObject.truckLocation.city +
            ', ' +
            columnObject.truckLocation.state +
            ', ' +
            columnObject.truckLocation.country;
        }
        return {
          ...columnObject,
          originDetails: originDetails,
          destinationDetails: destinationDetails,
          groupIdOrigin: groupIdOrigin,
          groupIdDestination: groupIdDestination,
          railOriginGroup: originName,
          trucksPerCar: columnObject.trucksPerCar
            ? columnObject.trucksPerCar
            : '0',
          transloadType: columnObject.transloadType
            ? columnObject.transloadType.displayText
            : '',
          truckType: columnObject.truckType
            ? columnObject.truckType.displayText
            : '',
          stcc: columnObject.stcc ? columnObject.stcc.productCode : '',
          railDestinationGroup: destinationName,
          customerRate: this.formatToFixed(columnObject.customerRate, '$0.00'),
        };
      }
    );
  }

  createProduceRailTruckTableRows() {
    this.railTruckRows = this.responseData.truckTransloadRailRates.map(
      (columnObject: any) => {
        let originName = '';
        let destinationName = '';
        let groupIdOrigin = '';
        let groupIdDestination = '';
        let originDetails = '';
        let destinationDetails = '';
        if (this.publicProgramData?.moveType.toLowerCase() === 'origin') {
          originName =
            columnObject.truckLocation.city +
            ', ' +
            columnObject.truckLocation.state +
            ', ' +
            columnObject.truckLocation.country;
          originDetails =
            columnObject.truckLocation.name +
            ', ' +
            columnObject.truckLocation.city +
            ', ' +
            columnObject.truckLocation.state +
            ', ' +
            columnObject.truckLocation.country;
          destinationName = columnObject.destnationRailGroup;
          groupIdDestination = columnObject.destnationRailGroup;
        }
        if (this.publicProgramData?.moveType.toLowerCase() === 'destination') {
          originName = columnObject.originRailGroup;
          groupIdOrigin = columnObject.originRailGroup;
          destinationName =
            columnObject.truckLocation.city +
            ', ' +
            columnObject.truckLocation.state +
            ', ' +
            columnObject.truckLocation.country;
          destinationDetails =
            columnObject.truckLocation.name +
            ', ' +
            columnObject.truckLocation.city +
            ', ' +
            columnObject.truckLocation.state +
            ', ' +
            columnObject.truckLocation.country;
        }
        return {
          ...columnObject,
          originDetails: originDetails,
          destinationDetails: destinationDetails,
          groupIdOrigin: groupIdOrigin,
          groupIdDestination: groupIdDestination,
          railOriginGroup: originName,
          trucksPerCar: columnObject.trucksPerCar
            ? columnObject.trucksPerCar
            : '0',
          transloadType: columnObject.transloadType
            ? columnObject.transloadType.displayText
            : '',
          truckType: columnObject.truckType
            ? columnObject.truckType.displayText
            : '',
          stcc: columnObject.stcc ? columnObject.stcc.productCode : '',
          railDestinationGroup: destinationName,
          customerRate: this.formatToFixed(columnObject.customerRate, '$0.00'),
        };
      }
    );
  }

  /** rows for transload */
  createTransloadRows() {
    this.transloadRows = [...this.responseData.transloadRates];
    this.transloadRows.forEach((columnObject: any) => {
      columnObject.service =
        'Transload (' + columnObject.transloadType.description + ')';
      columnObject.equipmentType = columnObject.equipmentType
        ? columnObject.equipmentType.displayText
        : '';
      columnObject.equipmentSubType = columnObject.equipmentSubType
        ? columnObject.equipmentSubType.displayText
        : '';
      columnObject.trucks = columnObject.trucksPerCar;
      columnObject.stcc = columnObject.stcc
        ? columnObject.stcc.productCode
        : '';
      columnObject.transloadType = columnObject.transloadType
        ? columnObject.transloadType.displayText
        : '';
      columnObject.truckType = columnObject.truckType = columnObject.truckType
        ? columnObject.truckType.displayText
        : '';
      columnObject.rates =
        this.formatToFixed(columnObject.customerRate, '$0.00') +
        ' ' +
        columnObject.rateUOM?.description;
    });
  }

  /** rows for truck */
  createTruckRows() {
    this.truckRows = [...this.responseData.truckRates];
    this.truckRows.forEach((columnObject: any) => {
      let originDetails = '';
      let destinationDetails = '';
      if (
        columnObject.originLocationDTO.name &&
        columnObject.originLocationDTO.city &&
        columnObject.originLocationDTO.state &&
        columnObject.originLocationDTO.country
      ) {
        originDetails =
          columnObject.originLocationDTO.name +
          ', ' +
          columnObject.originLocationDTO.city +
          ', ' +
          columnObject.originLocationDTO.state +
          ', ' +
          columnObject.originLocationDTO.country;
      }
      if (
        columnObject.destinationLocationDTO?.name &&
        columnObject.destinationLocationDTO.city &&
        columnObject.destinationLocationDTO.state &&
        columnObject.destinationLocationDTO.country
      ) {
        destinationDetails =
          columnObject.destinationLocationDTO.name +
          ', ' +
          columnObject.destinationLocationDTO.city +
          ', ' +
          columnObject.destinationLocationDTO.state +
          ', ' +
          columnObject.destinationLocationDTO.country;
      }
      columnObject.railOriginGroup =
        columnObject.originLocationDTO.city +
        ', ' +
        columnObject.originLocationDTO.state +
        ', ' +
        columnObject.originLocationDTO.country;
      columnObject.railDestinationGroup =
        columnObject.destinationLocationDTO.city +
        ', ' +
        columnObject.destinationLocationDTO.state +
        ', ' +
        columnObject.destinationLocationDTO.country;
      columnObject.truckType = columnObject.truckType
        ? columnObject.truckType.displayText
        : '';
      columnObject.stcc = columnObject.stcc
        ? columnObject.stcc.productCode
        : '';
      columnObject.originDetails = originDetails;
      columnObject.destinationDetails = destinationDetails;
      columnObject.baseRate =
        this.formatToFixed(columnObject.customerRate, '$0.00') +
        ' ' +
        columnObject.rateUOM?.description;
    });
  }

  createTransloadTruckTableRows() {
    this.transloadTruckRows = this.responseData.truckTransloadRates.map(
      (columnObject: any) => {
        let originName = '';
        let destinationName = '';
        let originDetails = '';
        let destinationDetails = '';
        if (this.publicProgramData?.moveType.toLowerCase() === 'origin') {
          originName =
            columnObject.originLocationDTO.city +
            ', ' +
            columnObject.originLocationDTO.state +
            ', ' +
            columnObject.originLocationDTO.country;
          originDetails =
            columnObject.originLocationDTO.name +
            ', ' +
            columnObject.originLocationDTO.city +
            ', ' +
            columnObject.originLocationDTO.state +
            ', ' +
            columnObject.originLocationDTO.country;
          destinationName =
            columnObject.destinationLocationDTO.city +
            ', ' +
            columnObject.destinationLocationDTO.state +
            ', ' +
            columnObject.destinationLocationDTO.country;
          destinationDetails =
            columnObject.destinationLocationDTO.name +
            ', ' +
            columnObject.destinationLocationDTO.city +
            ', ' +
            columnObject.destinationLocationDTO.state +
            ', ' +
            columnObject.destinationLocationDTO.country;
        }
        if (this.publicProgramData?.moveType.toLowerCase() === 'destination') {
          originName =
            columnObject.originLocationDTO.city +
            ', ' +
            columnObject.originLocationDTO.state +
            ', ' +
            columnObject.originLocationDTO.country;
          originDetails =
            columnObject.originLocationDTO.name +
            ', ' +
            columnObject.originLocationDTO.city +
            ', ' +
            columnObject.originLocationDTO.state +
            ', ' +
            columnObject.originLocationDTO.country;
          destinationName =
            columnObject.destinationLocationDTO.city +
            ', ' +
            columnObject.destinationLocationDTO.state +
            ', ' +
            columnObject.destinationLocationDTO.country;
          destinationDetails =
            columnObject.destinationLocationDTO.name +
            ', ' +
            columnObject.destinationLocationDTO.city +
            ', ' +
            columnObject.destinationLocationDTO.state +
            ', ' +
            columnObject.destinationLocationDTO.country;
        }
        return {
          ...columnObject,
          originDetails: originDetails,
          destinationDetails: destinationDetails,
          railOriginGroup: originName,
          transloadType: columnObject.transloadType
            ? columnObject.transloadType.displayText
            : '',
          equipmentSubType: columnObject.equipmentSubType
            ? columnObject.equipmentSubType.displayText
            : '',
          equipmentType: columnObject.equipmentType
            ? columnObject.equipmentType.displayText
            : '',
          truckType: columnObject.truckType
            ? columnObject.truckType.displayText
            : '',
          stcc: columnObject.stcc ? columnObject.stcc.productCode : '',
          railDestinationGroup: destinationName,
          customerRate: this.formatToFixed(columnObject.customerRate, '$0.00'),
        };
      }
    );
  }

  createProduceTransloadTruckTableRows() {
    this.transloadTruckRows = this.responseData.truckTransloadRates.map(
      (columnObject: any) => {
        let originName = '';
        let destinationName = '';
        let originDetails = '';
        let destinationDetails = '';
        if (this.publicProgramData?.moveType.toLowerCase() === 'origin') {
          originName =
            columnObject.originLocationDTO.city +
            ', ' +
            columnObject.originLocationDTO.state +
            ', ' +
            columnObject.originLocationDTO.country;
          originDetails =
            columnObject.originLocationDTO.name +
            ', ' +
            columnObject.originLocationDTO.city +
            ', ' +
            columnObject.originLocationDTO.state +
            ', ' +
            columnObject.originLocationDTO.country;
          destinationName =
            columnObject.destinationLocationDTO.city +
            ', ' +
            columnObject.destinationLocationDTO.state +
            ', ' +
            columnObject.destinationLocationDTO.country;
          destinationDetails =
            columnObject.destinationLocationDTO.name +
            ', ' +
            columnObject.destinationLocationDTO.city +
            ', ' +
            columnObject.destinationLocationDTO.state +
            ', ' +
            columnObject.destinationLocationDTO.country;
        }
        if (this.publicProgramData?.moveType.toLowerCase() === 'destination') {
          originName =
            columnObject.originLocationDTO.city +
            ', ' +
            columnObject.originLocationDTO.state +
            ', ' +
            columnObject.originLocationDTO.country;
          originDetails =
            columnObject.originLocationDTO.name +
            ', ' +
            columnObject.originLocationDTO.city +
            ', ' +
            columnObject.originLocationDTO.state +
            ', ' +
            columnObject.originLocationDTO.country;
          destinationName =
            columnObject.destinationLocationDTO.city +
            ', ' +
            columnObject.destinationLocationDTO.state +
            ', ' +
            columnObject.destinationLocationDTO.country;
          destinationDetails =
            columnObject.destinationLocationDTO.name +
            ', ' +
            columnObject.destinationLocationDTO.city +
            ', ' +
            columnObject.destinationLocationDTO.state +
            ', ' +
            columnObject.destinationLocationDTO.country;
        }
        return {
          ...columnObject,
          originDetails: originDetails,
          destinationDetails: destinationDetails,
          railOriginGroup: originName,
          railDestinationGroup: destinationName,
          transloadType: columnObject.transloadType
            ? columnObject.transloadType.displayText
            : '',
          equipmentSubType: columnObject.equipmentSubType
            ? columnObject.equipmentSubType.displayText
            : '',
          equipmentType: columnObject.equipmentType
            ? columnObject.equipmentType.displayText
            : '',
          truckType: columnObject.truckType
            ? columnObject.truckType.displayText
            : '',
          stcc: columnObject.stcc ? columnObject.stcc.productCode : '',
          customerRate: this.formatToFixed(columnObject.customerRate, '$0.00'),
        };
      }
    );
  }

  /** rows for storage */
  createStorageRows() {
    this.storageRows = [...this.responseData.storageRates];
    this.storageRows.forEach((columnObject: any) => {
      let rate =
        '$0.00 ' +
        columnObject.rateUOM?.description +
        ' ' +
        columnObject.forEachUOM?.description;
      if (columnObject.customerRate) {
        rate =
          columnObject.rateUOM && columnObject.rateUOM.description
            ? this.formatToFixed(columnObject.customerRate, '$0.00') +
              ' ' +
              columnObject.rateUOM.description +
              ' ' +
              columnObject.forEachUOM.description
            : this.formatToFixed(columnObject.customerRate, '$0.00');
      }
      if (!columnObject.customerRate) {
        rate =
          this.formatToFixed(columnObject.customerRate, '$0.00') +
          ' ' +
          columnObject.rateUOM.description +
          ' ' +
          columnObject.forEachUOM.description;
      }
      columnObject.rate = rate;
      columnObject.storageTier =
        columnObject.storageTierFromDays +
        ' - ' +
        columnObject.storageTierToDays;
      columnObject.service = columnObject.accessoriailServiceType
        ? columnObject.accessoriailServiceType.description
        : '';
      columnObject.stcc = columnObject.stcc
        ? columnObject.stcc.productCode
        : '';
      columnObject.service = columnObject.accessoriailServiceType
        ? columnObject.accessoriailServiceType.description
        : '';
      columnObject.serviceLocation =
        columnObject.destinationLocationDTO.city +
        ', ' +
        columnObject.destinationLocationDTO.state +
        ', ' +
        columnObject.destinationLocationDTO.country;
    });
  }

  /** rows for value added */
  createValueAddedRows() {
    this.addidationalChargesRows = [...this.responseData.accessorialRates];
    this.addidationalChargesRows.forEach((columnObject: any) => {
      let rate = '$0.00 ' + columnObject.rateUOM.description;
      if (columnObject.customerRate) {
        rate =
          columnObject.rateUOM && columnObject.rateUOM.description
            ? this.formatToFixed(columnObject.customerRate, '$0.00') +
              ' ' +
              columnObject.rateUOM.description
            : this.formatToFixed(columnObject.customerRate, '$0.00');
      }
      columnObject.rate = rate;
      columnObject.stcc = columnObject.stcc
        ? columnObject.stcc.productCode
        : '';
      columnObject.service = columnObject.accessoriailServiceType
        ? columnObject.accessoriailServiceType.description
        : '';
      columnObject.serviceLocation =
        columnObject.destinationLocationDTO.city +
        ', ' +
        columnObject.destinationLocationDTO.state +
        ', ' +
        columnObject.destinationLocationDTO.country;
    });
  }

  getReviewScreenData() {
    if (!this.isServiceCallOn) {
      this.showNoDataAvailable = false;
      this.showReviewDetails = false;
      this.isServiceCallOn = true;
      this.rateProvisionData = [];
      this.rows = [];
      this.railTruckRows = [];
      this.transloadRows = [];
      this.truckRows = [];
      this.storageRows = [];
      this.provisionsList = [];
      this.addidationalChargesRows = [];
      this.commentData = '';

      this.publicProgramService
        .getPublicProgramRate({ programId: this.currentId })
        .subscribe((responseTableDetails: any) => {
          if (responseTableDetails) {
            this.responseData = responseTableDetails;
            this.validateTableRowsData();
            this.rateProvisionData = responseTableDetails.provisions;
            if (this.rateProvisionData && this.rateProvisionData.length > 0) {
              this.sortProvisions();
            }
            this.showReviewDetails = true;
            this.isServiceCallOn = false;
          } else {
            this.showNoDataAvailable = true;
          }
        });
    }
  }

  validateTableRowsData() {
    if (
      this.responseData.railCarTypes &&
      this.responseData.railCarTypes.length > 0
    ) {
      if (this.selectedRailServices) {
        if (
          this.publicProgramData?.commodityCategory?.description === 'Produce'
        ) {
          /** produce as categort and service as rail transload table 1 */
          if (
            this.responseData.railRates &&
            this.responseData.railRates.length > 0
          ) {
            this.createProduceTableRows();
          }
        } else {
          /** non-produce as categort and service as rail transload table 1 */
          this.columns = this.columns.filter((col) => col.value !== 'product');
          if (
            this.responseData.railRates &&
            this.responseData.railRates.length > 0
          ) {
            this.createTableRows();
          }
        }
      }
    }
    /** transloadTruck */
    if (
      this.responseData.truckTransloadRates &&
      this.responseData.truckTransloadRates.length > 0
    ) {
      if (this.selectedTransloadTruckServices) {
        if (
          this.publicProgramData?.commodityCategory?.description === 'Produce'
        ) {
          /** produce as categort and service as rail truck table 2  */
          if (
            this.responseData.truckTransloadRates &&
            this.responseData.truckTransloadRates.length > 0
          ) {
            this.createProduceTransloadTruckTableRows();
          }
        } else {
          /** non-produce as categort and service as rail truck table 2  */
          this.transloadTruckColumns = this.transloadTruckColumns.filter(
            (col) => col.value !== 'product'
          );
          if (
            this.responseData.truckTransloadRates &&
            this.responseData.truckTransloadRates.length > 0
          ) {
            this.createTransloadTruckTableRows();
          }
        }
      }
    }
    if (
      this.responseData.transloadRates &&
      this.responseData.transloadRates.length > 0
    ) {
      if (this.selectedRailTruckServices) {
        if (
          this.publicProgramData?.commodityCategory?.description === 'Produce'
        ) {
          /** produce as categort and service as rail truck table 2  */
          if (
            this.responseData.truckTransloadRailRates &&
            this.responseData.truckTransloadRailRates.length > 0
          ) {
            this.createProduceRailTruckTableRows();
          }
        } else {
          /** non-produce as categort and service as rail truck table 2  */
          this.railTruckColumns = this.railTruckColumns.filter(
            (col) => col.value !== 'product'
          );
          if (
            this.responseData.truckTransloadRailRates &&
            this.responseData.truckTransloadRailRates.length > 0
          ) {
            this.createRailTruckTableRows();
          }
        }
      }
    }

    if (
      this.responseData.transloadRates &&
      this.responseData.transloadRates.length > 0
    ) {
      this.createTransloadRows();
    }
    if (
      this.responseData.truckRates &&
      this.responseData.truckRates.length > 0
    ) {
      this.createTruckRows();
    }
    if (
      this.responseData.storageRates &&
      this.responseData.storageRates.length > 0
    ) {
      this.createStorageRows();
    }
    if (
      this.responseData.accessorialRates &&
      this.responseData.accessorialRates.length > 0
    ) {
      this.createValueAddedRows();
    }
  }

  publishPublicProgram() {
    if (!this.isServiceCallOn) {
      if (this.rateProvisionData && this.rateProvisionData.length === 0) {
        window.alert('Please select rate provisions.');
        return;
      }
      this.isServiceCallOn = true;
      this.publicProgramService
        .publishPublicProgram(this.currentId)
        .subscribe((response: any) => {
          if (response.data) {
            this.updateStatus.emit();
            this.isServiceCallOn = false;
          }
        });
    }
  }

  get sortedItems() {
    return this.rateProvisionData.sort(
      (a, b) => a.displaySequenceNumber - b.displaySequenceNumber
    );
  }

  openOverlay() {
    this.isOverlayOpen = true;
  }

  closeOverlay() {
    this.isOverlayOpen = false;
    this.isTableOverlayOpen = false;
  }

  railGroupClick(event) {
    this.locationRows = [];
    this.isTableOverlayOpen = false;
    const requestObj = {
      query: 'OMAHA',
      locationType: 'CITY_STATE',
      groupName: event.groupName,
    };
    this.publicProgramService
      .getLocationsByGroupName(requestObj)
      .subscribe((res: any) => {
        this.locationType = event.name;
        this.locationRows = [...res];
        this.isTableOverlayOpen = true;
      });
  }

  openNewTab(link) {
    window.open(link, '_blank');
  }

  openOutlook() {
    this.tryOpenOutlookWeb(this.publicProgramData?.email);
  }

  tryOpenOutlookWeb(email) {
    const urlStart = 'https://';
    const outlookWebUrl =
      urlStart + `outlook.office.com/mail/deeplink/compose?to=${email}`;
    /**  Open Outlook Web */
    const newWindow = window.open(outlookWebUrl, '_blank');
    /** Detect pop-up block */
    if (
      !newWindow ||
      newWindow.closed ||
      typeof newWindow.closed === 'undefined'
    ) {
      alert('Pop-up blocked! Please allow pop-ups for this site.');
    }
  }

  downloadDocument() {
    this.publicProgramService
      .downloadPublicProgramDetailsPdf(this.publicProgramData?.id)
      .subscribe({
        next: (blob) => {
          const fileName = this.commonService.buildFileName(
            `public-program-${this.publicProgramData?.id}`
          );
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        },
      });
  }
}
